/* VELÁRI theme behaviours */
(function () {
  'use strict';

  var money = function (cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  };

  /* ---------- mobile menu ---------- */
  document.addEventListener('click', function (e) {
    var burger = e.target.closest('[data-menu-toggle]');
    if (!burger) return;
    var menu = document.getElementById('MobileMenu');
    if (!menu) return;
    var open = menu.classList.toggle('is-open');
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  /* ---------- cart drawer ---------- */
  var drawer = document.getElementById('CartDrawer');

  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    var close = drawer.querySelector('.drawer__close');
    if (close) close.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); refreshCart().then(openDrawer); }
    if (e.target.closest('[data-cart-close]')) { e.preventDefault(); closeDrawer(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  function refreshCart() {
    return fetch(window.velari.routes.cart + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('#CartDrawerContents');
        var target = document.querySelector('#CartDrawerContents');
        if (fresh && target) target.innerHTML = fresh.innerHTML;
        var count = doc.querySelector('[data-cart-count]');
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          if (count) el.textContent = count.textContent;
        });
      })
      .catch(function () { /* fall back to full page cart */ });
  }

  /* ---------- add to cart ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-add-to-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
    fetch(window.velari.routes.add, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: form.querySelector('[name="id"]').value, quantity: form.querySelector('[name="quantity"]').value || 1 }]
      })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCart(); })
      .then(openDrawer)
      .catch(function () { form.submit(); })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Add to bag'; }
      });
  });

  /* ---------- change line quantity ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    e.preventDefault();
    fetch(window.velari.routes.change, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: btn.dataset.line, quantity: btn.dataset.qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
        return refreshCart();
      });
  });

  /* ---------- quantity stepper ---------- */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty-step]');
    if (!step) return;
    var input = step.parentElement.querySelector('input');
    if (!input) return;
    var next = parseInt(input.value, 10) + parseInt(step.dataset.qtyStep, 10);
    input.value = Math.max(1, next);
  });

  /* ---------- before / after slider ---------- */
  document.querySelectorAll('[data-ba]').forEach(function (frame) {
    var range = frame.querySelector('.ba__range');
    if (!range) return;
    var apply = function () {
      frame.style.setProperty('--ba-pct', range.value + '%');
      frame.style.setProperty('--ba-inset', (100 - range.value) + '%');
    };
    range.addEventListener('input', apply);
    apply();
  });

  /* ---------- FAQ accordion ---------- */
  document.addEventListener('click', function (e) {
    var q = e.target.closest('.faq__q');
    if (!q) return;
    var item = q.closest('.faq__item');
    var open = item.classList.contains('is-open');
    item.parentElement.querySelectorAll('.faq__item').forEach(function (i) {
      i.classList.remove('is-open');
      i.querySelector('.faq__q').setAttribute('aria-expanded', 'false');
      i.querySelector('.faq__sign').textContent = '+';
    });
    if (!open) {
      item.classList.add('is-open');
      q.setAttribute('aria-expanded', 'true');
      item.querySelector('.faq__sign').textContent = '–';
    }
  });

  /* ---------- product variant selection ---------- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (root) {
    var data = JSON.parse(root.querySelector('[data-variant-json]').textContent);
    var form = document.querySelector('[data-add-to-cart]');
    var idField = form ? form.querySelector('[name="id"]') : null;

    function selected() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option-group]'), function (g) {
        var active = g.querySelector('.is-active');
        return active ? active.dataset.value : null;
      });
    }

    function match(values) {
      return data.variants.find(function (v) {
        return values.every(function (val, i) { return val === null || v.options[i] === val; });
      });
    }

    function update() {
      var values = selected();
      var variant = match(values);
      var priceEl = document.querySelector('[data-price]');
      var instEl = document.querySelector('[data-installment]');
      var btn = form ? form.querySelector('[type="submit"]') : null;

      root.querySelectorAll('[data-option-group]').forEach(function (g) {
        var label = g.querySelector('[data-option-selected]');
        var active = g.querySelector('.is-active');
        if (label && active) label.textContent = active.dataset.value;
      });

      if (variant && idField) idField.value = variant.id;
      if (variant && priceEl) priceEl.textContent = money(variant.price);
      if (variant && instEl) instEl.textContent = '4 × ' + money(Math.round(variant.price / 4)) + ' interest-free';
      if (btn) {
        var ok = variant && variant.available;
        btn.disabled = !ok;
        btn.textContent = ok ? 'Add to bag' : 'Sold out';
      }
      if (variant && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-value]');
      if (!opt) return;
      var group = opt.closest('[data-option-group]');
      group.querySelectorAll('[data-value]').forEach(function (o) {
        o.classList.remove('is-active');
        o.setAttribute('aria-pressed', 'false');
      });
      opt.classList.add('is-active');
      opt.setAttribute('aria-pressed', 'true');
      update();
    });

    update();
  });

  /* ---------- product gallery thumbs ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (gal) {
    gal.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-thumb]');
      if (!thumb) return;
      var main = gal.querySelector('[data-gallery-main] img');
      if (main) {
        main.src = thumb.dataset.thumb;
        main.srcset = '';
      }
      gal.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });
})();
